import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useContext } from "react";
import { Context } from "../contexts/GlobalContext";
import { UI_LANGUAGES, UI_LANGUAGE_SHORT } from "../utils/languages.js";

// Language names are deliberately NOT translated — each is written in its own
// language so it stays recognisable whatever the current UI locale is.
const FLAGS = { en: "🇺🇸", ru: "🇷🇺", uz: "🇺🇿", "uz-Cyrl": "🇺🇿" };
const LANGUAGES = UI_LANGUAGES.map((l) => ({ code: l.code, label: l.label, flag: FLAGS[l.code] || "" }));

export const LangSelector = ({ fullWidth = true }) => {
  const { i18n } = useTranslation();
  const { setLang } = useContext(Context);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLang(lng);
    // localStorage.setItem('i18nextLng', lng); // handled by GlobalContext/i18n
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className={`${fullWidth ? 'w-full' : 'w-auto'} flex items-center justify-center gap-2 rounded-lg shadow-sm hover:bg-gray-50`}
        >
          <Globe className="w-4 h-4" />
          <span className="text-sm font-medium">{UI_LANGUAGE_SHORT[i18n.language] || i18n.language.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-36">
        {LANGUAGES.map(({ code, label, flag }) => (
          <DropdownMenuItem key={code} onClick={() => changeLanguage(code)}>
            <span aria-hidden="true">{flag}</span>
            <span className="flex-1">{label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
